import { useQuery } from '@apollo/react-hooks';
import { GET_MERIT } from './GET_MERIT.gql';
import { type GetMerit, type MeritFormData } from './types';
import { checkInvalidDate } from '../checkInvalidDate';

export const useGetMerit = (id: string): GetMerit => {
  const {
    data: meritData,
    loading,
    error,
  } = useQuery(GET_MERIT, {
    variables: { id },
    skip: !id,
    fetchPolicy: 'network-only',
  });

  const {
    meritName,
    awardBodyName,
    awardDate,
    country,
    attainmentMeans,
    supportingDocuments = [],
  } = (meritData?.merit as MeritFormData) ?? {};

  const meritFormData: MeritFormData = {
    meritName,
    awardBodyName,
    awardDate: checkInvalidDate(awardDate) ? null : awardDate,
    country,
    attainmentMeans,
    supportingDocuments,
  };

  return { meritFormData, loading, error };
};
